module.exports = __webpack_public_path__ + "img/loader.f9384d57.gif";